import React from 'react';
import { COLORS, TOP_INDENTS } from '@constants';
import { Button, Typography } from '@ui';
import { Col, Row } from 'antd';
import { StyledList } from './styled';

const HowToFindServiceAccountEmail = ({ close }) => {
    return (
        <Row justify='center'>
            <Col span={16} justify='center' align='center'>
                <video width='400' controls muted style={{ marginBottom: '16px' }}>
                    <source src='https://cdn.klickly.com/boa_videos/view_access.mp4' type='video/mp4' />
                    Your browser does not support the video tag.
                </video>
                <StyledList>
                    <li>
                        <Typography.Text type='body2'>
                            <b>Navigate to Admin:</b> Open your Google Analytics 4 dashboard and click the Admin gear
                            icon in the bottom left corner.
                        </Typography.Text>
                    </li>
                    <li>
                        <Typography.Text type='body2'>
                            <b>Open Access Management:</b> In the second column (Property), click on Property Access
                            Management.
                        </Typography.Text>
                    </li>
                    <li>
                        <Typography.Text type='body2'>
                            <b>Add the Email:</b> Click the blue + icon to add a new user. Paste the Klickly service
                            email, assign it the Viewer role, and click &apos;Add&apos;.
                        </Typography.Text>
                    </li>
                </StyledList>
                <Button
                    backgroundColor={COLORS.$white}
                    padding='0 58px'
                    justify='center'
                    style={TOP_INDENTS.XL_PLUS}
                    onClick={close}
                >
                    Close
                </Button>
            </Col>
        </Row>
    );
};

export default HowToFindServiceAccountEmail;
